<div class="container-fluid p-3">
  <div class="page-header mb-4">
    <div class="d-flex justify-content-between align-items-center">
      <div>
        <h4 class="mb-1">User Certificate</h4>
        <h5 class="text-primary">[{{ payload?.proposal_name }}]</h5>
        <div class="status-badge">
          <span class="badge" [ngClass]="{
              'bg-secondary': stepDetails?.step_status == 0,
              'bg-success': stepDetails?.step_status == 'approved',
              'bg-warning': stepDetails?.step_status == 'recommended',
              'bg-info': stepDetails?.step_status == 'initiated'
            }">
            {{
            stepDetails?.step_status == 0
            ? "INITIATION PENDING"
            : (stepDetails?.step_status | uppercase)
            }}
          </span>
        </div>
      </div>

      <div class="action-buttons">
        <button class="btn btn-outline-secondary me-2" (click)="generatePDF()">
          <i class="pi pi-file-pdf me-1"></i> PDF
        </button>

        <ng-container *ngIf="stepDetails?.step_status == 'approved'">
          <button class="btn btn-outline-primary me-2" (click)="goToNextStep()">
            Next <i class="pi pi-angle-right ms-1"></i>
          </button>
        </ng-container>

        <ng-container *ngIf="stepDetails?.can_edit">
          <button class="btn btn-primary me-2" (click)="routeConfig.emit({isRouteConfig: true}) " [disabled]="commentForm?.invalid">
            <i class="pi pi-save me-1"></i> Save/Forward/Route Config
          </button>
        </ng-container>

      </div>
    </div>
  </div>

  <hr class="my-3" />

  <div class="row mb-4">
    <app-upload-document [title]="stepDetails.name+' Document'" [isEditable]="stepDetails?.can_edit">  </app-upload-document>
    
  </div>

  <form [formGroup]="commentForm">
    <div class="col-md-8 my-3 d-flex gap-2">
      <label class="bg-primary text-white p-2 w-25 "> Trial Completion Date <b class="text-warning">*</b></label>
      <input type="date" class="form-control" formControlName="date" [disabled]="isEditorDisabled" />
    </div>
    <div class="mb-4 editor-container" [class.readonly-editor]="isEditorDisabled">
      <p class="bg-primary text-white p-2 ">
        {{ schemeType === 'rev' ? 'Comment' : 'Justification' }} 
      </p>

      <editor [init]="init" formControlName="final_offer" [disabled]="isEditorDisabled"></editor>
    </div>

  </form>
</div>